import {
  USERS_LOGIN,
  USERS_OTP,
  USERS_ORGANIZATION,
  ALL_ORGANIZATION_USERS,
  VERIFY_SESSION,
  LOGOUT_SESSION,
} from "../../api/Actions/SsoB3/SsoB3";

let initialState = {
  UsersLogin: false,
  errorUsersLogin: false,
  UsersOtp: false,
  errorUsersOtp: false,
  UsersOrg: false,
  errorUsersOrg: false,
  OrgUsers: false,
  errorOrgUsers: false,
  VerifySession: false,
  errorVerifySession: false,
  LogoutSession: false,
  errorLogoutSession: false,
};

export const UsersLogin = (state = initialState, action) => {
  switch (action.type) {
    case USERS_LOGIN:
      return {
        ...state,
        UsersLogin: action.payload.data,
        errorUsersLogin: action.payload.errorMessage,
      };
    case USERS_OTP:
      return {
        ...state,
        UsersOtp: action.payload.data,
        errorUsersOtp: action.payload.errorMessage,
      };
    case USERS_ORGANIZATION:
      return {
        ...state,
        UsersOrg: action.payload.data,
        errorUsersOrg: action.payload.errorMessage,
      };
    case ALL_ORGANIZATION_USERS:
      return {
        ...state,
        OrgUsers: action.payload.data,
        errorOrgUsers: action.payload.errorMessage,
      };
    case VERIFY_SESSION:
      return {
        ...state,
        VerifySession: action.payload.data,
        errorVerifySession: action.payload.errorMessage,
      };
    case LOGOUT_SESSION:
      return {
        ...state,
        LogoutSession: action.payload.data,
        errorLogoutSession: action.payload.errorMessage,
      };
    default:
      return state;
  }
};
